import React from 'react';
import FormWizard from '../../components/FormWizard/FormWizard';
import Drawer from '../Drawer/Drawer';
import ErrorMsg from '../ErrrorMsg/ErrorMsg';
import SuccessMsg from '../SuccessMsg/SuccessMsg';

interface ISuccessErrDrawerProps {
  open?: boolean;
  onClose?: (e?: any) => void;
  successMsg?: string;
  errMsg?: string;
  className?: string;
  title?: string;
  subTitle?: string;
}

const SuccessErrDrawer: React.FC<React.PropsWithChildren<ISuccessErrDrawerProps>> = ({
  open,
  onClose,
  successMsg,
  errMsg,
  className,
  title,
  subTitle,
}) => {
  return (
    <Drawer
      direction="right"
      open={open}
      onClose={onClose}
      className={className}
    >
      <FormWizard
        open={open}
        onClose={onClose}
        title={title}
        subTitle={subTitle}
        nextBtnLabel="Close"
        onBack={onClose}
        onNext={onClose}
        hideClearBtn
        drawerView
      >
        <div className="py-8">
          {!!errMsg && <ErrorMsg message={errMsg} />}

          {!!successMsg && <SuccessMsg message={successMsg} />}
        </div>
      </FormWizard>
    </Drawer>
  );
};
export default SuccessErrDrawer;
